import React, { useEffect, useState } from 'react';
import HomepageButton from './buttons/Homepage';
import LikeButton from './buttons/Like';
import ShareButton from './buttons/Share';
import TranslateButton from './buttons/Translate';
import ChattingButton from './buttons/Chatting';

import * as MODE from '../../../common/constants/live/mode';
import * as SHARE from '../../../common/constants/live/share';

export default function InfoWrapper(props) {
  const [isMSIE, setIsMSIE] = useState(true);

  useEffect(() => {
    const ua = window.navigator.userAgent;
    setIsMSIE(ua.indexOf('MSIE') > -1 ? true : false);
  }, []);

  const onClickLikeButton = () => {
    props.onClickLikeButton();
  };
  const onClickShareButton = (platform, event) => {
    const shareTitle = encodeURIComponent(props.data.title);
    const shareUrl = encodeURIComponent(window.location.href);
    if (platform === 'facebook') {
      window.open(
        `${SHARE.URL_FACEBOOK}?t=${shareTitle}&u=${shareUrl}`,
        '',
        ''
      );
    } else if (platform === 'twitter') {
      window.open(
        `${SHARE.URL_TWITTER}?text=${shareTitle}&url=${shareUrl}`,
        '',
        ''
      );
    } else if (platform === 'kakaostory') {
      window.open(
        `${SHARE.URL_KAKAOSTORY}?content=${shareTitle}&url=${shareUrl}`,
        '',
        ''
      );
    } else if (platform === 'clipboard') {
      let tempTextArea = document.createElement('textarea');
      tempTextArea.value = window.location.href;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      tempTextArea.setSelectionRange(0, 9999);
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
      alert(`${window.location.href} 가 클립보드에 복사 되었습니다.`);
      if (event?.currentTarget.id)
        document.getElementById(event.currentTarget.id).focus();
    }
  };
  const onClickTranslateButton = () => {
    props.onChangeMode(MODE.LIVE_MODE_TRANSLATE);
  };
  const onClickChattingButton = () => {
    props.onChangeMode(MODE.LIVE_MODE_CHATTING);
  };

  const onChangeFocus = () => {
    props.onChangeFocus(null);
  };

  return (
    <div className="live_info_w">
      <div
        className="live_info_inner"
        tabIndex="0"
        aria-label={`현재 방송중인 프로그램은 ${
          props.data.channelname
        } 채널의 ${props.data.title} 입니다. 방송 예정 시간은 ${
          props.data.time
        } 까지 입니다. 
    ${
      (props.data.channelid === 'S17' || props.data.channelid === 'S18') &&
      props.data.guest_name
        ? `보는라디오 게스트는 ${props.data.guest_name} 입니다.`
        : ''
    }`}
      >
        <h2 className="live_info_channel">{props.data.channelname}</h2>
        <div className="live_info_title">{props.data.title}</div>
        <div className="live_subinfo_w">
          <div className="live_subinfo_time">
            방송시간
            <span className="lsi_time_number">{`${props.data.time}`}</span>
          </div>
          <div className="mb_label_w live_subinfo_guest">
            {(props.data.channelid === 'S17' ||
              props.data.channelid === 'S18') && (
              <span className="mb_label_bora" title="보는라디오">
                보라
              </span>
            )}
            {props.data.guest_name && (
              <span className="lsi_guest_name">{props.data.guest_name}</span>
            )}
          </div>
        </div>
      </div>
      <div className="live_btns_w">
        <HomepageButton {...props.data} />
        <LikeButton {...props.data} onClick={onClickLikeButton} />
        <ShareButton {...props.data} onClick={onClickShareButton} />
        {!isMSIE &&
          props.data.programid &&
          props.data.programid.indexOf('P451172214') === -1 && (
            <TranslateButton
              {...props.data}
              focus={props.focusname === 'translate'}
              onChangeFocus={onChangeFocus}
              onClick={onClickTranslateButton}
            />
          )}
        {!isMSIE && (
          <ChattingButton
            {...props.data}
            focus={props.focusname === 'chatting'}
            onChangeFocus={onChangeFocus}
            onClick={onClickChattingButton}
          />
        )}
      </div>
    </div>
  );
}
